import React from "react";
import { Modal, Button, Image } from "react-bootstrap";

//STYLES
import * as ViewerStyles from "../styles/imageViewer";

import "../styles/viewer.css";

function ImageViewer(props) {
    return (
        <div>
            <Modal dialogClassName="modal-width" show={props.open} onHide={props.handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Image</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-height">
                    <Image style={ViewerStyles.imageSize} src={props.imageURL} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ImageViewer;
